<template>
    <FormInputContainer class="FormNumber" :inputId="`I${_uid}`" :label="label" :sublabel="sublabel" :errors="errors">
        <input
            :id="`I${_uid}`"
            v-bind="$attrs"
            type="number"
            :value="value"
            :step="step"
            v-on="{ [lazy ? 'change' : 'input']: handleInput }"
        />
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormNumber',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: Number },
        label: { type: String },
        sublabel: { type: String },
        step: { type: Number, default: 1 },
        lazy: { type: Boolean, default: false },
        errors: { type: Array },
    },

    methods: {
        handleInput(event) {
            if (event.target.validity.badInput) {
                event.target.value = this.value;
                return;
            }

            const parseType = this.step < 1 ? 'parseFloat' : 'parseInt';
            const result = Number[parseType](event.target.value, 10);

            this.$emit('input', Number.isFinite(result) ? result : null);
        },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.FormNumber {
    input {
        @extend %form-control;
        padding-right: 10px;
    }
}
</style>
